export enum ViewType {
  LIST = 'LIST',
  MAP = 'MAP',
}

// France coordinates
export enum DefaultViewport {
  SOUTH = 41.34277,
  WEST = -5.14225,
  NORTH = 51.08916,
  EAST = 9.55979,
}
